import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="survey-html-scaler"
//
// Renders the variant iframe at a fixed "desktop" virtual viewport
// (`virtualWidth`, defaults to 1900px) so the page always lays out as
// desktop, then visually shrinks it with a CSS transform so it fills
// the variant container — be it a wide 19:12 card, a tall portrait card
// on mobile, or a phone bezel.
//
// The iframe's pixel height is recomputed from the container's actual
// height so the scaled iframe perfectly fills the container without
// letterboxing, regardless of the container's aspect ratio.
//
// Markup contract:
//   <div class="survey-html-viewer-frame"
//        data-controller="survey-html-scaler"
//        data-survey-html-scaler-virtual-width-value="1900">
//     <iframe data-survey-html-scaler-target="iframe" ...></iframe>
//   </div>
export default class extends Controller {
  static targets = ["iframe"]
  static values = {
    virtualWidth: { type: Number, default: 1900 }
  }

  connect() {
    this.observer = new ResizeObserver(() => this.updateScale())
    this.observer.observe(this.element)
    this.updateScale()
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect()
      this.observer = null
    }
  }

  updateScale() {
    if (!this.hasIframeTarget || this.virtualWidthValue <= 0) return

    const width = this.element.clientWidth
    const height = this.element.clientHeight
    if (!width || !height) return

    const scale = width / this.virtualWidthValue
    // The iframe's CSS height must be `height / scale` so that, after
    // the transform is applied, its painted height matches the
    // container's real height exactly.
    this.iframeTarget.style.height = `${height / scale}px`
    this.iframeTarget.style.transform = `scale(${scale})`
  }
}
